import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {REMIT_BASE_URL} from './config';

@Injectable({
  providedIn: 'root',
})
export class RemitUserDetailService {
  constructor(
    private http: HttpClient,
    @Inject(REMIT_BASE_URL) private remitApiUrl: string,
  ) {}

  getUserDetail(userId: string): Observable<RemitUserDetailResponse> {
    return this.http.get<RemitUserDetailResponse>(
        `${this.remitApiUrl}/staff/user-detail/${userId}`,
    );
  }
}

export interface RemitUserDetailResponse {
  message: string;
  body: RemitUserDetail;
}
export interface RemitUserDetail {
  id: string;
  userId: string;
  whatsappNumber: string;
  createdAt: string;
  createdBy: string;
  updatedAt: string;
  updatedBy: string;
  version: string;
}

